export default function plurals(
    value,
    singularNominativ,
    pluralNominativ,
    pluralGenitive = pluralNominativ,
    boldValue = false,
    valueColor = null,
    noDisplayValue = false
) {
    let displayValue = boldValue ? `<strong>${value}</strong>` : value
    if (valueColor) {
        const tmp = displayValue
        displayValue = `<span style="color:${valueColor}">${tmp}</span>`
    }
    if (noDisplayValue) {
        displayValue = ''
    }

    if (value === 1) {
        return displayValue + ' ' + singularNominativ
    } else if (
        value % 10 >= 2 &&
        value % 10 <= 4 &&
        (value % 100 < 10 || value % 100 >= 20)
    ) {
        return displayValue + ' ' + pluralNominativ
    } else {
        return displayValue + ' ' + pluralGenitive
    }
}
